import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-printer",
  "use": "icon-printer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-printer\">\r\n  <path d=\"M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z\" fill=\"currentColor\" />\r\n  <path d=\"M820 296H204c-44.2 0-80 35.8-80 80v280c0 44.2 35.8 80 80 80h116v148c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V736h116c44.2 0 80-35.8 80-80V376c0-44.2-35.8-80-80-80z m-480 0h344v120H340V296z m304 568H380V584h264v280z m256-208c0 8.8-7.2 16-16 16H716V552c0-17.7-14.3-32-32-32H340c-17.7 0-32 14.3-32 32v120H204c-8.8 0-16-7.2-16-16V376c0-8.8 7.2-16 16-16h616c8.8 0 16 7.2 16 16v280z\" fill=\"currentColor\" />\r\n  <path d=\"M424 632h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H424c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM424 752h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H424c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/printer.svg
// module id = Jn9L
// module chunks = 117